var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFormatQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#202020",
  fillRule: "evenodd",
  d: "M12 3v4.5A7.5 7.5 0 0 0 4.5 15H12v12H0V15l.006-.374C.203 8.172 5.498 3 12 3Zm18 0v4.5a7.5 7.5 0 0 0-7.5 7.5H30v12H18V15l.006-.374c.193-6.33 5.29-11.427 11.62-11.62L30 3Z",
  clipRule: "evenodd"
})));
export { SvgFormatQuote as ReactComponent };
export default __webpack_public_path__ + "static/media/format_quote.9976b217243a063e4e2c.svg";